export default {
getRequestById:state=>id=>{
  var ind = state.newRequests.findIndex(x=>x.id==id);
  if(ind!=-1&&ind!=undefined){
    return state.newRequests[ind];
  }
  else return null
}

}
